/**
 * #1826 — gelijktijdig bewerken: per veld drie standen. `basis` is wat het formulier bij het
 * openen kende, `mijn` wat de gebruiker nu heeft, `hun` wat er nu op de server staat.
 *
 * | wie wijzigde           | uitkomst                                  |
 * |------------------------|-------------------------------------------|
 * | alleen ik              | versturen                                 |
 * | alleen de ander        | overnemen in het formulier, niet versturen |
 * | allebei, gelijk        | niets                                     |
 * | allebei, verschillend  | botsing: niets opslaan, de gebruiker kiest |
 *
 * Een lijst of object (alternatieve namen, feiten) is één veld.
 */

/** Stabiele JSON: objectsleutels gesorteerd (jsonb geeft ze in eigen volgorde terug). */
export const stabiel = (v: unknown): string =>
  JSON.stringify(v, (_k, w) =>
    w && typeof w === 'object' && !Array.isArray(w)
      ? Object.fromEntries(Object.entries(w).sort(([a], [b]) => a.localeCompare(b)))
      : w
  );

export type Botsing = { veld: string; mijn: unknown; hun: unknown };

export function driewegVergelijking(
  basis: Record<string, unknown>,
  mijn: Record<string, unknown>,
  hun: Record<string, unknown>,
  velden: string[] = Object.keys(mijn)
): { versturen: string[]; overnemen: Record<string, unknown>; botsingen: Botsing[] } {
  const versturen: string[] = [];
  const overnemen: Record<string, unknown> = {};
  const botsingen: Botsing[] = [];
  for (const veld of velden) {
    const b = stabiel(basis[veld]);
    const m = stabiel(mijn[veld]);
    const h = stabiel(hun[veld]);
    if (m === b) {
      if (h !== b) overnemen[veld] = hun[veld];
    } else if (h === b) versturen.push(veld);
    else if (h !== m) botsingen.push({ veld, mijn: mijn[veld], hun: hun[veld] });
  }
  return { versturen, overnemen, botsingen };
}
